import './src/assets/sass/main.scss';

const shouldPreserveToolScroll = location =>
  location.pathname === '/flaunt-tools/' &&
  location.state?.preserveToolScroll;

const shouldSmoothScrollToTop = location => location.state?.scrollToTop;

export const shouldUpdateScroll = ({ routerProps: { location } }) =>
  !shouldPreserveToolScroll(location) && !shouldSmoothScrollToTop(location);

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (
    prevLocation &&
    location.action !== 'POP' &&
    shouldSmoothScrollToTop(location)
  ) {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
  }
};
